import React from 'react';

// Utility function to format the amount
export const formatAmount = (amount) => {
    return amount ? amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : '0';
};

class Format extends React.Component {
    render() {
        const { value } = this.props;

        return (
            <>
                {formatAmount(value)}
            </>
        );
    }
}

export default Format;
